
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Users, FileText, BarChart3, Database, Shield } from 'lucide-react';

const AdminDashboard = () => {
  const adminTools = [
    {
      title: 'User Impersonation',
      description: 'Login as any user for support',
      icon: Users,
      href: '/admin/impersonate'
    },
    {
      title: 'Audit Log',
      description: 'View system activity logs',
      icon: FileText,
      href: '/admin/audit-log'
    },
    {
      title: 'System Metrics',
      description: 'Monitor app performance',
      icon: BarChart3,
      href: '/admin/system-metrics'
    },
    {
      title: 'Database Tools',
      description: 'Manage database operations',
      icon: Database,
      href: '/admin/database'
    },
    {
      title: 'Backups',
      description: 'System backup management',
      icon: Shield,
      href: '/admin/backups'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-juv-cream to-juv-sage/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="space-y-6">
          {/* Header */}
          <div>
            <h1 className="text-3xl font-bold font-juv-heading text-juv-deep-chestnut">
              Admin Dashboard
            </h1>
            <p className="mt-1 text-juv-deep-chestnut/70">
              System administration and utility tools
            </p>
          </div>

          {/* Admin Tools Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {adminTools.map((tool) => (
              <Card key={tool.title} className="bg-white shadow-luxury border border-juv-rose-clay/30 hover:shadow-xl transition-shadow cursor-pointer">
                <CardHeader>
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-juv-terracotta/20 rounded-lg flex items-center justify-center">
                      <tool.icon className="h-6 w-6 text-juv-terracotta" />
                    </div>
                    <div>
                      <CardTitle className="font-juv-heading text-juv-deep-chestnut">
                        {tool.title}
                      </CardTitle>
                      <p className="text-sm text-juv-deep-chestnut/70">{tool.description}</p>
                    </div>
                  </div>
                </CardHeader>
                <CardContent>
                  <Button size="sm" className="w-full bg-juv-terracotta text-white">
                    Access Tool
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
